import { Provider, providerToScope } from "@p0security/shared/types/assessment";
import { Typography } from "@p0security/ui";

import { AllIntegrationLogos } from "../../../Integrations/IntegrationLogo.tsx";

export type SupportedProvider = (typeof SupportedProviders)[number];
const SupportedProviders = ["aws", "gcloud"] as const;
function isSupportedProvider(source: string): source is SupportedProvider {
  return SupportedProviders.includes(source as SupportedProvider);
}

export const KeyLink: React.FC<{
  projectId: string;
  serviceAccountId: string;
  keyId: string;
  source: Provider;
}> = ({ projectId, serviceAccountId, keyId, source }) => {
  const fixedSource = providerToScope(source);
  if (isSupportedProvider(fixedSource)) {
    const logo = AllIntegrationLogos[fixedSource];
    const urls: Record<SupportedProvider, string> = {
      gcloud: `https://console.cloud.google.com/iam-admin/serviceaccounts/details/${serviceAccountId}/keys?project=${projectId}`,
      aws: `https://console.aws.amazon.com/iam/home?#/users/${serviceAccountId}`,
    };

    return (
      <Typography.Link href={urls[fixedSource]} target="_blank" rel="noopener">
        {keyId}&nbsp;{logo}
      </Typography.Link>
    );
  }
  return <>{keyId}</>;
};
